module.exports = __webpack_public_path__ + "9144425b215d06dc81c5bff8de72bce6.svg";